import type { DevCouriersState } from 'app/store/dev/couriers/couriers.reducer';
import type { DevDocumentsState } from 'app/store/dev/documents/documents.reducer';
import { createFeatureSelector } from '@ngrx/store';
import { initialDevCouriersState } from 'app/store/dev/couriers/couriers.reducer';
import { initialDevDocumentsState } from 'app/store/dev/documents/documents.reducer';

const devFeatureKey = 'dev';

export const selectDevState = createFeatureSelector<DevState>(devFeatureKey);

export interface DevState {
  couriers: DevCouriersState;
  documents: DevDocumentsState;
}

export const initialDevState: DevState = {
  couriers: initialDevCouriersState,
  documents: initialDevDocumentsState,
};
